import { data_select, builder_id } from "../results-load/results-state";
import { filterCity, filterPrice, filterZone } from "./results-prefilters";
function getStringFilter(field, list) {
    return list.reduce((text, element, index) => {
        const value = element.tipo ? `${element.tipo},${element.modo}` : element;
        return text + (index > 0 ? `,${value}` : value);
    }, `${field}=`);
}
export function filterString() {
    var _a;
    let stringFilter = '';
    // Obtener nid desde la URL
    const urlParams = new URLSearchParams(window.location.search);
    const nidParam = ((_a = urlParams.get('nid')) !== null && _a !== void 0 ? _a : "").replace(/\s+/g, "+");
    Object.keys(data_select).forEach(element => {
        if (data_select[element].length > 0) {
            const nameField = element == 'order' ? 'sort' : element;
            stringFilter = stringFilter
                ? stringFilter + '&' + getStringFilter(nameField, data_select[element])
                : getStringFilter(nameField, data_select[element]);
        }
    });
    // Agregar builder
    if (builder_id > 0) {
        stringFilter += stringFilter
            ? `&builder=${builder_id}`
            : `builder=${builder_id}`;
    }
    // Agregar nid solo si existe en la URL y tiene más de un valor
    if (nidParam) {
        const nidValues = nidParam.split('+').filter(Boolean);
        if (nidValues.length > 1) {
            stringFilter += stringFilter
                ? `&nid=${nidValues.join('+')}`
                : `nid=${nidValues.join('+')}`;
        }
    }
    return stringFilter ? `?${stringFilter}` : stringFilter;
}
export function orderValues(listValues) {
    const tempList = listValues ? valuesToInt(listValues) : [];
    const list = tempList.filter((x) => !isNaN(x.filter))
        .sort((a, b) => xToNumber(a.filter) - xToNumber(b.filter));
    const listNonNumber = tempList.filter((x) => isNaN(x.filter));
    return [...list, ...listNonNumber];
}
function valuesToInt(ListValues) {
    return ListValues.map(element => ({
        ...element,
        filter: !isNaN(element.filter.replace(/"/g, '')) ? parseInt(element.filter.replace(/"/g, '')) : element.filter.replace(/"/g, '')
    }));
}
function xToNumber(value) {
    return Number(value);
}
export function filterNid(filter, section = '') {
    const queryString = window.location.search;
    let nid;
    if (!filter.includes('nid') && queryString.includes('nid')) {
        const urlParams = new URLSearchParams(queryString);
        nid = urlParams.get('nid');
        filter += `&nid=${nid}`;
        if (section == 'prefilter') {
            data_select['nid'].push(nid);
        }
    }
    return filter;
}
export function filterIndex(filter, section = '') {
    const queryString = window.location.search;
    let index;
    if (!filter.includes('index') && queryString.includes('index')) {
        const urlParams = new URLSearchParams(queryString);
        index = urlParams.get('index');
        filter += `&index=${index}`;
        if (section == 'prefilter') {
            data_select['index'].push(index);
        }
    }
    return filter;
}
export function filterSort(filter, section = '') {
    const queryString = window.location.search;
    if (!filter.includes('sort') && queryString.includes('sort')) {
        const urlParams = new URLSearchParams(queryString);
        const sort = urlParams.get('sort');
        filter += `&sort=${sort}`;
        if (section == 'prefilter') {
            data_select['sort'].push(sort);
        }
    }
    return filter;
}
export function buildMapFilter() {
    let filter = filterString();
    filter += filter ? `&url=${window.location.pathname}` : `?url=${window.location.pathname}`;
    filter = filterCity(filter);
    filter = filterZone(filter);
    filter = filterPrice(filter);
    filter = filterSort(filter);
    return filter;
}
